<template>
    <div class="emoji-wrapper" ref="emojiWrapper">
        <span
            class="btn reactions-btn add-reaction-btn"
            :class="{ 'add-reaction-hover': isHover }"
            @click="togglePicker"
            ><span class="emoji-item"
                ><img :class="{ 'add-reaction-img': isHover }" src="../../../assets/images/chat/add-reaction.svg"
            /></span>
        </span>
        <div v-if="showPicker" class="picker-popup" :class="pickerPosition">
            <Picker :data="emojiIndex" :showPreview="false" :perLine="8" :emojiSize="18" @select="onEmojiSelect" />
        </div>
    </div>
</template>

<script lang="ts" src="./EmojiPicker.ts"></script>
<style lang="scss" src="./EmojiPicker.scss"></style>
